import React, { Fragment } from "react";
import { Flex, Box } from "rebass";
import { css } from "styled-components";
import SEO from "../components/seo";
import { Facebook, Radio, Instagram, IconWithLink } from "../components/icons";
import imgsrcPlxTl from "../images/plx-tl.jpg";
import imgsrcPlxTr from "../images/plx-tr.jpg";
import imgsrcPlxBl from "../images/plx-bl.jpg";
import imgsrcPlxBr from "../images/plx-br.jpg";
import theme from "../../theme";
import { Link, useStaticQuery, graphql } from "gatsby";

function ensureLeadingSlash(path) {
  if (!path) return "";
  return path[0] === "/" ? path : `/${path}`;
}

function linkItemUrlItem(indexPageReadMoreLink) {
  const aTag = {
    url: null,
    title: null,
  };

  if (indexPageReadMoreLink.page) {
    aTag.url = indexPageReadMoreLink.page.slug;
    aTag.title = indexPageReadMoreLink.page.title;
    if (indexPageReadMoreLink.title) {
      aTag.title = indexPageReadMoreLink.title;
    }
  } else {
    aTag.url = ensureLeadingSlash(indexPageReadMoreLink.slug);
    aTag.title = indexPageReadMoreLink.title;

    if (indexPageReadMoreLink.externalUrl) {
      aTag.url = indexPageReadMoreLink.externalUrl;
    }
  }
  return aTag;
}

const IndexPage = () => {
  const { flags, contentfulGlobalSettings: settings } = useStaticQuery(graphql`
    {
      flags: allContentfulFeatures {
        edges {
          node {
            hideSchema
          }
        }
      }
      contentfulGlobalSettings {
        ticketLink
        indexPageReadMoreLink {
          page {
            slug
            title
          }
          slug
          title
          externalUrl
        }
      }
    }
  `);
  return (
    <Fragment>
      <Flex
        color="red"
        width={1}
        alignItems="flex-end"
        css={css`
          background-color: ${theme.colors.bottom};
          position: absolute;
          z-index: 1;
          left: 0;
          border-bottom: 1px solid;
          text-transform: uppercase;
          line-height: 1;
        `}
      >
        {flags.edges[0].node.hideSchema ? (
          <Box
            as="a"
            href={settings.ticketLink}
            fontSize={3}
            fontWeight="bold"
            height="40px"
            lineHeight="40px"
            letterSpacing="14px"
            textAlign="center"
            flex={1}
            css={css`
              text-transform: uppercase;
              &:hover {
                background: ${theme.colors.primary};
                color: black;
                border: 0px solid;
              }
            `}
          >
            TICKETS
          </Box>
        ) : (
          <Box
            fontSize={3}
            fontWeight="bold"
            height="40px"
            lineHeight="40px"
            letterSpacing="14px"
            textAlign="center"
            flex={1}
            css={css`
              text-transform: uppercase;
              &:hover {
                background: ${theme.colors.primary};
                color: black;
                border: 0px solid;
              }
            `}
          >
            <Link to="/schema">Schema</Link>
          </Box>
        )}
        <Flex>
          <IconWithLink
            css={{
              padding: "4px",
            }}
            icon={Radio}
            link="https://www.mixcloud.com/malmoantenn/stream/"
          />
          <IconWithLink
            icon={Facebook}
            link="https://www.facebook.com/plxplxplx"
          />
          <IconWithLink
            icon={Instagram}
            link="https://www.instagram.com/plxplxplx/"
          />
        </Flex>
      </Flex>

      <SEO title="PLX Tjärö 2021" keywords={["festival", "tjärö"]} />
      <Flex
        alignItems={["flex-end"]}
        css={css`
          min-height: calc(100vh - 180px);
          position: relative;
          @media (min-width: 1024px) {
            min-height: calc(100vh - 110px);
          }
        `}
      >
        <Box
          pt={["0vh", 6]}
          pb={["100px", 6]}
          css={css`
            max-width: 76vw;
            @media (min-width: 1024px) {
              width: 50vw;
              max-width: 800px;
            }
          `}
        >
          <Box
            fontSize={[3, 4, 5, 5, 6]}
            css={css`
              background-color: ${theme.colors.primary};
              display: inline;
              line-height: 1.4;
              @media (min-width: 1024px) {
                display: inline;
              }
            `}
          >
            PLX Tjärö 19-22 augusti i Blekinge skärgård.
            <br />
          </Box>
          {settings.indexPageReadMoreLink ? (
            <Box
              fontSize={[2, 2, 2, 2, 3]}
              css={css`
              background-color: #000;
              color: ${theme.colors.primary};
              display: inline-block;
              &:hover {
                background: ${theme.colors.primary};
                color: black;
                border: 0px solid;
            `}
            >
              <Link to={linkItemUrlItem(settings.indexPageReadMoreLink).url}>
                {linkItemUrlItem(settings.indexPageReadMoreLink).title}
              </Link>
            </Box>
          ) : null}
        </Box>
        <Box
          css={css`
            display: none;
            @media (min-width: 14px) {
              position: absolute;
              z-index: -1;
              bottom: 31px;
              right: 0;
              display: grid;
              grid-template-columns: repeat(12, 1fr);
              grid-template-rows: repeat(12, 1fr);
              height: calc(100vh - 210px);
              width: calc(100vh - 210px);
            }
            @media (min-width: 1024px) {
              bottom: 102px;
              right: 6vw;
              height: calc(100vh - 300px);
              width: calc(100vh - 300px);
            }
          `}
        >
          <Box
            css={css`
              @media (min-width: 14px) {
                background-color: rgba(0, 0, 0, 0.4);
                background-image: url(${imgsrcPlxBr});
                background-size: cover;
                grid-column: 5 / 10;
                grid-row: 8 / 13;
                @media (min-width: 1024px) {
                  grid-column: 8 / 12;
                  grid-row: 9 / 13;
                }
              }
            `}
          ></Box>
          <Box
            css={css`
              @media (min-width: 14px) {
                background-color: rgba(0, 0, 0, 0.4);
                background-image: url(${imgsrcPlxTl});
                background-size: cover;
                grid-column: 4 / 9;
                grid-row: 1 / 6;
                @media (min-width: 1024px) {
                  grid-column: 1 / 6;
                }
              }
            `}
          ></Box>
          <Box
            css={css`
              @media (min-width: 10px) {
                background-color: rgba(0, 0, 0, 0.4);
                background-image: url(${imgsrcPlxBl});
                background-size: cover;
                grid-column: 8 / 13;
                grid-row: 7 / 12;
                @media (min-width: 1024px) {
                  grid-column: 3 / 9;
                  grid-row: 4 / 10;
                }
              }
            `}
          ></Box>
          <Box
            css={css`
              @media (min-width: 14px) {
                background-color: rgba(0, 0, 0, 0.4);
                background-image: url(${imgsrcPlxTr});
                background-size: cover;
                grid-column: 10 / 13;
                grid-row: 2 / 5;
                @media (min-width: 1024px) {
                  grid-row: 1/ 4;
                }
              }
            `}
          ></Box>
        </Box>
      </Flex>
    </Fragment>
  );
};

export default IndexPage;
